import React from "react";

export const PreviousBtn = (props) => {
    const { onClick } = props;
    return (
        <React.Fragment>
            <div onClick={onClick}>
                <span className="leftarrow" > &#8249; </span>
            </div>
        </React.Fragment>
    );
};
export const NextBtn = (props) => {
    const { onClick } = props;
    return (
        <React.Fragment>
            <div onClick={onClick}>
                <span className="rightarrow" >&#8250;</span>
            </div>
        </React.Fragment>
    );
};
export const ProductPreviousBtn = (props) => {
    const { onClick } = props;
    return (
        <React.Fragment>
            <div onClick={onClick}>
                <span className="productLeftArrow" > &#8249; </span>
            </div>
        </React.Fragment>
    );
};
export const ProductNextBtn = (props) => {
    const { onClick } = props;
    return (
        <React.Fragment>
            <div onClick={onClick}>
                <span className="productRightArrow" >&#8250;</span>
            </div>
        </React.Fragment>
    );
};


export const GreenOutButton = (props) => {
    return (
        <React.Fragment>
            <button type={props.btnTtype} className={`${props.css} successBtn outBtnCSs`} disabled={props.disabled} onClick={props.handleSubmit}>{props.title}</button>
        </React.Fragment>
    )
}
export const RedOutButton = (props) => {
    return (
        <React.Fragment>
            <button type="button" className="dangerBtn outBtnCSs" onClick={props.handleSubmit}>{props.title}</button>
        </React.Fragment>
    )
}
export const BlackOutButton = (props) => {
    return (
        <React.Fragment>
            <button type="button" className={`${props.css} darkBtn outBtnCSs`} onClick={props.handleSubmit}>{props.title}</button>
        </React.Fragment>
    )
}
export const GreenButton = (props) => {
    return (
        <React.Fragment>
            <button type="submit" disabled={props.disabled} className={`${props.css} greenBtn`} onClick={props.handleSubmit}>{props.title}</button>
        </React.Fragment>
    )
}